import { IMatchingActivityProps } from "../../properties/ActivityProperties";
import {
  parseBodyMapFromData,
  parseContentMapFromData,
  parseMaterialMapFromData,
} from "../../utilization/CatchtivityUtilization";
import ActivityBodyContent from "./body-contents/ActivityBodyContent";
import MatchingActivityMaterialContent from "./material-contents/MatchingActivityMaterialContent";
import ActivitySolveLayout from "./ActivitySolveLayout";

const MatchingActivityContent = ({
  answerMap,
  data,
  canAnswerQuestion,
  changeAnswer,
  isPreview,
  showCorrectAnswer,
  isFullScreen,
  passage,
}: IMatchingActivityProps) => {
  const contentMap = parseContentMapFromData(data);
  const matchingBodyMap = parseBodyMapFromData(data, "MATCHING");
  const matchingMaterialMap = parseMaterialMapFromData(data, "MATCHING");

  const handleMatchingAnswerOnChange = (
    answerMap: any,
    key: any,
    value: string | null,
  ) => {
    if (isPreview) return;
    answerMap[key] = value;
    changeAnswer(answerMap);
  };

  return (
    <ActivitySolveLayout
      variant="wide"
      isFullScreen={isFullScreen}
      passage={passage}
      body={
        <ActivityBodyContent
          bodyMap={matchingBodyMap}
          templateType={"MATCHING"}
        />
      }
      interaction={
        <MatchingActivityMaterialContent
          uniqueValue={JSON.stringify(data.contentMap)}
          answerMap={answerMap}
          materialMap={matchingMaterialMap}
          contentMap={contentMap}
          checkCanAnswerQuestion={canAnswerQuestion}
          onChange={handleMatchingAnswerOnChange}
          isPreview={isPreview}
          showCorrectAnswer={showCorrectAnswer}
        />
      }
    />
  );
};

export default MatchingActivityContent;
